module.exports = __webpack_public_path__ + "img/SL-M-180-200.af6e4ac3.svg";